import { render, staticRenderFns } from "./moyIndex.vue?vue&type=template&id=1b36dcea&scoped=true&"
import script from "./moyIndex.vue?vue&type=script&lang=js&"
export * from "./moyIndex.vue?vue&type=script&lang=js&"
import style0 from "./moyIndex.vue?vue&type=style&index=0&id=1b36dcea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b36dcea",
  null
  
)

export default component.exports